export default __webpack_public_path__ + "static/media/logo-mediline-white.b795ac2a.png";